<template>
  <section class="main-container search text-center pt-10 pb-20 mx-auto">
    <div class="text-left mt-10">
      <component
        :is="currentComponent"
        :walletAddress="walletAddress"
        :publicAddress="walletAddress"
      />
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";

import CoinAccountComponent from '@/components/web/CoinAccountComponent';
import ProxyNftMintAccountComponent from '@/components/web/ProxyNftMintAccountComponent';
import ProxyMultisigAccountComponent from '@/components/web/ProxyMultisigAccountComponent';
import ProxyFundingAccountComponent from '@/components/web/ProxyFundingAccountComponent';
import ProxyTokenMintAccountComponent from '@/components/web/ProxyTokenMintAccountComponent';

import {
  AccountType,
  getAccountTypeFromBase58String } from '@/utils/accountType';

export default defineComponent({
  name: 'AccountWrapper',
  components: {
    CoinAccountComponent,
    ProxyNftMintAccountComponent,
    ProxyMultisigAccountComponent,
    ProxyFundingAccountComponent,
    ProxyTokenMintAccountComponent,
  },
  computed: {
    walletAddress() {
      return this.$route.params.address;
    },
    currentComponent() {
      const accountType = getAccountTypeFromBase58String(this.walletAddress);
      console.log('Account type:', accountType, 'walletAddress:', this.walletAddress);
      if (accountType !== null) {
        if (accountType === AccountType.CoinAsset) {
          return 'CoinAccountComponent';
        } else if (accountType === AccountType.ProxyMultisig) {
          return 'ProxyMultisigAccountComponent';
        } else if (accountType === AccountType.ProxyNftMint) {
          return 'ProxyNftMintAccountComponent';
        } else if (accountType === AccountType.ProxyFunding) {
          return 'ProxyFundingAccountComponent';
        } else if (accountType === AccountType.ProxyTokenMint) {
          return 'ProxyTokenMintAccountComponent';
        }
      }
      return '';
    },
  },
  data() {
    return {
      account: {},
    };
  },

});
</script>

<style scoped>
.main-container {
  max-width: 90vw;
  min-height: calc(100vh - 270px);
}
</style>
